import { gql } from '@apollo/client';

const query = gql`
  query searchSeoHome($params: JSONObject) {
    searchSeoHome(params: $params)
  }
`;

module.exports = query;
